import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GuideServiceProvider } from './types';

@Injectable({
  providedIn: 'root',
})
export class GuideService implements GuideServiceProvider {
  private _isGuideCompleted: boolean | null = null;
  private _isGuideCompletedSubject = new BehaviorSubject<boolean | null>(null);

  private _guideCompletedEndpoint = '/api/teams/guide-dismissed';

  constructor(private _http: HttpClient) {
    this._initGuideCompleted();
  }

  get isGuideCompleted$(): Observable<boolean | null> {
    return this._isGuideCompletedSubject.asObservable();
  }

  private _initGuideCompleted(): void {
    this._getGuideCompleted().subscribe((isGuideCompleted) => {
      this._isGuideCompleted = isGuideCompleted;
      this._isGuideCompletedSubject.next(isGuideCompleted);
    });
  }

  getGuideCompleted(): Observable<boolean> {
    return this._getGuideCompleted();
  }

  markGuideCompleted(): void {
    if (this._isGuideCompleted) {
      return;
    } else {
      this._markGuideCompleted().subscribe(() => {
        this._isGuideCompleted = true;
      });
    }
  }

  /**
   * Gets the guide completed status from the server.
   */
  private _getGuideCompleted(): Observable<boolean> {
    return this._http.get<boolean>(this._guideCompletedEndpoint);
  }

  /**
   * marks the guide as completed on the server.
   */
  private _markGuideCompleted(): Observable<boolean> {
    return this._http.put<boolean>(this._guideCompletedEndpoint, {});
  }
}
